"use client";

import cn from "@utils/cn";
import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import Image from "next/image";
import React, { FC } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import { PageIntroProps } from "@/types";

import "./PageIntro.css";

export const PageIntro: FC<PageIntroProps> = ({ entry }) => {
  const locale = useLocale();
  return (
    <section className="text-black py-m">
      <article className="mx-auto p-m pt-[40px] pb-[40px] md:p-0 md:w-20\/24 md:pt-[80px] md:pb-[30px] flex flex-col md:flex-row">
        <div className="flex flex-col md:w-[70%] md:pr-3xl">
          <h3 className="text-l text-left font-medium uppercase font-primary tracking-[2px] md:tracking-[3.2px] leading-6">{entry.description}</h3>
          {entry.cta && (
            <Button
              customClass="!hidden md:!block mt-xl md:mt-[72px] bg-black text-white w-fit font-medium !w-full md:!w-fit"
              size={ButtonSize.MEDIUM}
              href={getLink(entry.cta, locale)}
              target={entry.cta.link.target}
              theme={ButtonTheme.BLACK}
              type="button"
              variant={ButtonVariant.PRIMARY}
            >
              {entry.cta.label}
            </Button>
          )}
        </div>
        <div
          className={cn(
            "flex flex-col py-[72px] md:py-0 md:border-l-2 md:border-gray-20 md:pl-[90px]",
            entry.jobRole && entry.jobRole[0].image && "justify-center",
            entry.dataIdentity?.length === 3 ? "justify-between" : "justify-center",
          )}
        >
          {entry.jobRole
            ? entry.jobRole.map((role) => (
                <>
                  <div className="flex flex-col items-center">
                    <Image src={role.image.url} alt={role.image.title || ""} width={role.image.width} height={role.image.height} className="" />
                    <div className="mt-l text-m font-medium">{role.title && <p className="">{role.title}</p>}</div>
                    <div className="text-s mt-xs font-secondary-light">{role.text && <p className="">{role.text}</p>}</div>
                  </div>
                </>
              ))
            : entry.dataIdentity?.map((box, index) => (
                <div key={index} className="flex flex-col items-start md:items-center box-content">
                  <div className="text-l md:text-m font-primary md:font-secondary font-medium uppercase md:normal-case">
                    {box.title && <p className="">{box.title}</p>}
                  </div>
                  <div className="text-s mt-xs font-secondary-light">{box.text && <p className="">{box.text}</p>}</div>
                </div>
              ))}
        </div>
        {entry.cta && (
          <div className="md:hidden flex justify-center">
            <Button
              customClass="w-full justify-center text-center font-medium"
              size={ButtonSize.MEDIUM}
              href={getLink(entry.cta, locale)}
              target={entry.cta.link.target}
              theme={ButtonTheme.BLACK}
              type="button"
              variant={ButtonVariant.PRIMARY}
            >
              {entry.cta.label}
            </Button>
          </div>
        )}
      </article>
    </section>
  );
};

export default PageIntro;
